import { IMilestone } from "@/interfaces";

export const hasRequiredApprovers = (
  milestone: IMilestone,
  projectLeaders: Record<string, string>
): boolean => {
  if (!milestone.approvalRequired) return true;

  if (!milestone.approvers && !milestone.projectLeaderApprovers) return false;

  const hasMissingApprovers =
    milestone.projectLeaderApprovers?.some(
      (role) => !role.isNotApplicable && !projectLeaders[role.regionId]
    ) ||
    milestone.approvers?.some(
      (role) =>
        !role.isNotApplicable &&
        role.regionId &&
        (role.assignedUsers?.length || 0) === 0
    );

  if (hasMissingApprovers) return false;

  const hasApprovers = milestone.approvers?.some(
    (role) => role.assignedUsers?.length > 0
  );
  const hasProjectLeaderApprovers = milestone.projectLeaderApprovers?.some(
    (role) => !!projectLeaders[role.regionId]
  );

  return hasApprovers || hasProjectLeaderApprovers;
};
